import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "220",
  "slug": "best-geography-resources-university-students",
  "title": "The Best Free Geography Resources for University Students",
  "excerpt": "From open-access GIS tools to interactive satellite imagery games, here are the free resources every geography student should have bookmarked — curated for serious academic use.",
  "date": "2026-03-03",
  "category": "Education",
  "image": "/blog-images/world.jpg",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "A useful geography resource should support a task you need to complete: obtaining data, inspecting it, making a map, or reading the methods behind an analysis. Start with that task when choosing software and reference material."
    },
    {
      "type": "heading",
      "text": "GIS and Spatial Analysis Tools"
    },
    {
      "type": "paragraph",
      "text": "QGIS is the gold standard for free GIS software. It is open-source, runs on Windows, macOS, and Linux, and supports virtually every spatial data format you will encounter in your degree. The functionality rivals ArcGIS in most academic use cases, and there is an extensive library of community plugins for everything from terrain analysis to network routing."
    },
    {
      "type": "paragraph",
      "text": "Google Earth Engine offers free access to a petabyte-scale archive of satellite imagery alongside a cloud-based processing platform. Students can run analysis on decades of Landsat and Sentinel data without downloading anything. The JavaScript and Python APIs are well documented."
    },
    {
      "type": "heading",
      "text": "Open Data Sources Worth Bookmarking"
    },
    {
      "type": "list",
      "items": [
        "NASA Earthdata — free access to hundreds of datasets covering climate, land cover, ocean temperature, and atmospheric composition.",
        "USGS Earth Explorer — download Landsat, ASTER, and SRTM elevation data for any location on Earth.",
        "OpenStreetMap — the world's largest volunteer-built geographic database, useful for urban geography projects.",
        "Natural Earth — clean, well-maintained vector and raster data at multiple scales, essential for cartographic work.",
        "European Environment Agency data portal — comprehensive environmental datasets for Europe."
      ]
    },
    {
      "type": "heading",
      "text": "Learning Spatial Thinking Interactively"
    },
    {
      "type": "paragraph",
      "text": "For visual interpretation practice, choose an image and annotate the features you can recognise. EarthGuessr can provide a location-guessing exercise, but a game score is not a measure of competence in processing or validating remote sensing data."
    },
    {
      "type": "heading",
      "text": "Online Courses and Academic Reading"
    },
    {
      "type": "paragraph",
      "text": "For course material, start with your department’s reading list and the provider’s current access terms. For papers, use your library catalogue, Google Scholar, or Semantic Scholar, then check the paper itself. The Directory of Open Access Journals can help you find journals; do not assume every relevant article is free to read."
    }
  ],
  "imageAlt": "Earth regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
